import type { FaqItem } from '../types'

export const faqs: FaqItem[] = [
  {
    id: 'entrega',
    question: '¿De verdad lista en 7 días?',
    answer:
      'Sí. Una vez que apruebas el diseño y nos das tu información, la web está publicada y en línea en 7 días hábiles. Llevamos más de 100 proyectos entregados a tiempo.',
    highlight: '+100 proyectos entregados a tiempo',
  },
  {
    id: 'tecnologia',
    question: '¿Necesito saber de tecnología?',
    answer:
      'Para nada. Yo me encargo de absolutamente todo: dominio, hosting, diseño, textos, configuración técnica y publicación. Tú solo apruebas el resultado final y empiezas a recibir clientes.',
    highlight: 'Cero trabajo técnico de tu parte',
  },
  {
    id: 'diseno',
    question: '¿Qué pasa si no me gusta el diseño?',
    answer:
      'Incluimos rondas de revisión en todos los paquetes. El Esencial incluye 1, el Pro incluye 3 y el Elite es ilimitado. No te entregamos nada que no te encante.',
  },
  {
    id: 'pagos',
    question: '¿Puedo pagar en partes?',
    answer:
      'Sí. Aceptamos 50% de anticipo para arrancar y el 50% restante al entregar. Para el paquete Esencial son $300 para empezar y $300 al recibir tu web lista.',
    highlight: '50% para iniciar · 50% al entregar',
  },
  {
    id: 'dominio',
    question: '¿Incluye el dominio y el hosting?',
    answer:
      'El primer año de dominio y hosting está incluido en todos los paquetes. A partir del segundo año el mantenimiento es opcional y muy accesible.',
    highlight: 'Primer año incluido',
  },
]
